import { render, staticRenderFns } from "./FormTemplateAvatar.vue?vue&type=template&id=3c1fbee7&scoped=true&"
import script from "./FormTemplateAvatar.vue?vue&type=script&lang=js&"
export * from "./FormTemplateAvatar.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplateAvatar.vue?vue&type=style&index=0&id=3c1fbee7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1fbee7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c1fbee7')) {
      api.createRecord('3c1fbee7', component.options)
    } else {
      api.reload('3c1fbee7', component.options)
    }
    module.hot.accept("./FormTemplateAvatar.vue?vue&type=template&id=3c1fbee7&scoped=true&", function () {
      api.rerender('3c1fbee7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/FormTemplateAvatar.vue"
export default component.exports